<template>
<box-view title="Lịch sử nhập kho" class="stock-import-history" :showBack="true" @close="$router.push('/admin')">
    <div class="container">
    <!-- FILTER -->
    <div class="card mb-2 p-2">
    <div class="row g-2 align-items-center">
        <div class="col-md-4">
        <input
            v-model="searchQuery"
            class="form-control form-control-sm"
            placeholder="Tìm mã phiếu / sản phẩm"
        />
        </div>

        <div class="col-md-3">
        <input v-model="fromDate" type="date" class="form-control form-control-sm" />
        </div>

        <div class="col-md-3">
        <input v-model="toDate" type="date" class="form-control form-control-sm" />
        </div>
    </div>

    <!-- SUMMARY -->
    <div class="mt-2 pt-2 border-top d-flex flex-wrap justify-content-center justify-content-md-start">
        <div class="summary-box mr-4 me-4">
            <span class="text-muted small">Tổng SL nhập:</span>
            <span class="fw-bold ms-1 text-primary">{{ totalFilteredQty | formatNumber }}</span>
        </div>
        <div class="summary-box mr-4 me-4">
            <span class="text-muted small">Tổng giá trị:</span>
            <span class="fw-bold ms-1 text-danger">{{ totalFilteredAmount | formatCurrency }}</span>
        </div>
        <div class="summary-box">
            <span class="text-muted small">Số phiếu:</span>
            <span class="fw-bold ms-1 text-dark">{{ filteredImports.length | formatNumber }}</span>
        </div>
    </div>
    </div>

    <!-- TABLE -->
    <div class="table-responsive">
    <table class="table table-sm table-bordered align-middle">
        <thead class="table-info">
        <tr>
            <th>#</th>
            <th>Nhà cung cấp</th>
            <th>Sản phẩm</th>
            <th>Số lượng</th>
            <th>Giá vốn</th>
            <th>Thành tiền</th>
            <th>Loại</th>
            <th>Người nhập</th>
            <th>Ngày</th>
            <th width="90"></th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(i, index) in paginatedImports" :key="i.id">
            <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
            <td style="max-width: 150px;" class="text-truncate" :title="i.supplierName">{{ i.supplierName || '—' }}</td>
            <td>
            <b>{{ i.product.name }}</b>
            <div class="text-muted small">{{ i.product.code }}</div>
            </td>
            <td :class="{'text-danger': i.quantity < 0}">{{ i.quantity | formatNumber }}</td>
            <td>{{ i.product.costPrice | formatCurrency }}</td>
            <td class="fw-bold text-danger">{{ (i.totalAmount || (i.quantity * i.product.costPrice)) | formatCurrency }}</td>
            <td>
            <span
                :class="{
                'text-success': i.type === 'import',
                'text-danger': i.type === 'adjust'
                }"
            >
                {{ i.type === 'import' ? 'Nhập kho' : 'Điều chỉnh' }}
            </span>
            </td>
            <td>{{ i.user.name }}</td>
            <td>{{ formatTime(i.createdAt) }}</td>
            <td class="text-center">
            <button class="btn btn-sm btn-primary" @click="openDetail(i)">
                <i class="fas fa-eye"></i>
            </button>
            </td>
        </tr>

        <tr v-if="filteredImports.length === 0">
            <td colspan="9" class="text-center text-muted">
            Chưa có phiếu nhập
            </td>
        </tr>
        </tbody>
    </table>
    </div>

    <!-- PAGINATION -->
    <nav v-if="totalPages > 1" class="mt-2 container">
        <ul class="pagination pagination-sm justify-content-center flex-wrap">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a class="page-link" href="#" @click.prevent="goToPage(1)" title="Trang đầu">««</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a class="page-link" href="#" @click.prevent="goToPage(currentPage - 1)">«</a>
            </li>
            <li v-for="(page, idx) in visiblePages" :key="'p'+idx"
                class="page-item"
                :class="{ active: page === currentPage, disabled: page === '...' }">
                <a class="page-link" href="#"
                   @click.prevent="page !== '...' && goToPage(page)">{{ page }}</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <a class="page-link" href="#" @click.prevent="goToPage(currentPage + 1)">»</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <a class="page-link" href="#" @click.prevent="goToPage(totalPages)" title="Trang cuối">»»</a>
            </li>
        </ul>
        <div class="text-center text-muted small">Trang {{ currentPage }} / {{ totalPages }}</div>
    </nav>

    <!-- DETAIL / ADJUST POPUP -->
    <div v-if="showDetail" class="modal-backdrop-custom">
    <div class="modal-custom">

        <div class="modal-header bg-primary text-white">
        <h6 class="mb-0">Chi tiết phiếu nhập</h6>
        <button class="btn btn-sm btn-danger" @click="showDetail = false">✕</button>
        </div>

        <div class="modal-body">
        <p class="d-flex"><b class="mx-2">Mã phiếu:</b> {{ selected.id }}</p>
        <p v-if="selected.refCode" class="d-flex"><b class="mx-2">Phiếu gốc:</b> <span class="text-primary">{{ selected.refCode }}</span></p>
        <p class="d-flex"><b class="mx-2">Nhà cung cấp:</b> {{ selected.supplierName || '—' }}</p>
        <p class="d-flex"><b class="mx-2">Sản phẩm:</b> {{ selected.product.name }}</p>
        <p class="d-flex"><b class="mx-2">Số lượng:</b> {{ selected.quantity | formatNumber }}</p>
        <p class="d-flex"><b class="mx-2">Giá vốn:</b> {{ selected.product.costPrice | formatCurrency }}</p>
        <p class="d-flex text-danger fw-bold"><b class="mx-2">Thành tiền:</b> {{ (selected.totalAmount || (selected.quantity * selected.product.costPrice)) | formatCurrency }}</p>
        <p class="d-flex"><b class="mx-2">Ghi chú:</b> {{ selected.note || '—' }}</p>

        <hr />

        <h6 class="text-danger">⚠ Điều chỉnh nhập kho</h6>

        <div class="mb-2">
            <label class="form-label d-flex">Số lượng điều chỉnh (+ / -)</label>
            <money-input
            v-model="adjustQty"
            class="form-control form-control-sm"
            />
        </div>

        <div class="mb-2">
            <label class="form-label d-flex">Lý do</label>
            <input
            v-model="adjustNote"
            class="form-control form-control-sm"
            placeholder="Nhập sai / kiểm kho lệch..."
            />
        </div>
        </div>

        <div class="modal-footer">
        <button v-if="selected.type === 'import'" class="btn btn-sm btn-danger me-auto mr-auto" style="margin-right: auto;" @click="confirmDelete(selected)">
            Xoá phiếu này
        </button>
        <button class="btn btn-sm btn-warning" @click="confirmAdjust">
            Tạo phiếu điều chỉnh
        </button>
        </div>

    </div>
    </div>
    </div>


</box-view>
</template>
<script>
export default {
    name: 'StockImportHistory',
    props: {
        stockImports: {
            type: Array,
            default: () => []
        },
        user: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
    return {
        searchQuery: '',
        fromDate: '',
        toDate: '',
        showDetail: false,
        selected: null,
        adjustQty: 0,
        adjustNote: '',
        currentPage: 1,
        pageSize: 30,
    };
    },

    computed: {
    filteredImports() {
        const k = this.searchQuery.toLowerCase();

        return this.stockImports.filter(i => {
        const matchText =
            i.id.toLowerCase().includes(k) ||
            i.product.name.toLowerCase().includes(k);

        const d = new Date(i.createdAt);
        const from = this.fromDate ? new Date(this.fromDate) : null;
        const to = this.toDate ? new Date(this.toDate + ' 23:59:59') : null;

        const matchDate =
            (!from || d >= from) &&
            (!to || d <= to);

        return matchText && matchDate;
        });
    },
    totalFilteredQty() {
        return this.filteredImports.reduce((sum, i) => sum + parseFloat(i.quantity || 0), 0);
    },
    totalFilteredAmount() {
        return this.filteredImports.reduce((sum, i) => sum + parseFloat(i.totalAmount || (i.quantity * i.product.costPrice) || 0), 0);
    },
    totalPages() {
        return Math.ceil(this.filteredImports.length / this.pageSize);
    },
    visiblePages() {
        const total = this.totalPages;
        const current = this.currentPage;
        const delta = 2;
        const pages = [];
        if (total <= 7) {
            for (let i = 1; i <= total; i++) pages.push(i);
            return pages;
        }
        pages.push(1);
        const rangeStart = Math.max(2, current - delta);
        const rangeEnd = Math.min(total - 1, current + delta);
        if (rangeStart > 2) pages.push('...');
        for (let i = rangeStart; i <= rangeEnd; i++) pages.push(i);
        if (rangeEnd < total - 1) pages.push('...');
        pages.push(total);
        return pages;
    },
    paginatedImports() {
        const start = (this.currentPage - 1) * this.pageSize;
        return this.filteredImports.slice(start, start + this.pageSize);
    }
    },

    methods: {
    goToPage(page) {
        if (page < 1) page = 1;
        if (page > this.totalPages) page = this.totalPages;
        this.currentPage = page;
    },
    formatTime(t) {
        return new Date(t).toLocaleString();
    },

    openDetail(item) {
        // Extract Ref ID from note: " | Ref: NK-..."
        let refCode = '';
        if (item.note && item.note.includes('Ref: ')) {
            const parts = item.note.split('Ref: ');
            if (parts.length > 1) {
                refCode = parts[1].trim().split(' ')[0]; // Take first word after Ref:
            }
        }
        
        this.selected = { ...item, refCode };
        this.adjustQty = 0;
        this.adjustNote = '';
        this.showDetail = true;
    },

    confirmAdjust() {
        if (!this.adjustQty) return;

        const adjustment = {
        id: 'ADJ-' + Date.now(),
        type: 'adjust',
        product: this.selected.product,
        quantity: this.adjustQty,
        note: this.adjustNote,
        createdAt: new Date().toISOString(),
        user: this.user
        };

        this.$emit('adjust-stock', adjustment);

        this.showDetail = false;
    },

    confirmDelete(item) {
        if (!this.$dialog) {
             if (confirm(`Bạn có chắc muốn xóa phiếu nhập ${item.id}? Việc xóa phiếu sẽ làm giảm số lượng tồn kho tự động.`)) {
                 this.$emit('delete-stock-import', item.id);
                 this.showDetail = false;
             }
             return;
        }
        
        this.$dialog.confirm({
            title: 'Xác nhận xóa',
            message: `Bạn có chắc chắn muốn xóa phiếu nhập ${item.id}?\n\n- Tồn kho sản phẩm sẽ bị TRỪ LẠI đi ${item.quantity}.\n- Công nợ nhà cung cấp sẽ ĐƯỢC GIẢM đi tương ứng.\n\nHành động này không thể hoàn tác!`,
            confirmButtonText: 'Đồng ý xóa',
            cancelButtonText: 'Hủy',
            confirmButtonColor: '#ee0a24'
        }).then(() => {
            this.$emit('delete-stock-import', item.id);
            this.showDetail = false;
        }).catch(() => {});
    }
    }
};
</script>

<style scoped>
.modal-backdrop-custom {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-custom {
  background-color: white;
  border-radius: 5px;
  width: 500px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-header {
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  padding: 15px;
  overflow-y: auto;
}

.modal-footer {
  padding: 10px 15px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #eee;
}

.summary-box {
    padding: 4px 12px;
    border-radius: 4px;
    background: #f8f9fa;
    border: 1px solid #eee;
}
</style>

